import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_LOAD_CREATE_PREPARATION__FAIL,
  ACTION_LOAD_CREATE_PREPARATION__SUCCESS,
  ACTION_LOAD_CREATE_PREPARATION__REQUEST,
} from '../actionTypes';


const actionLoadCreatePreparationSuccess = createPreparation => ({
  type: ACTION_LOAD_CREATE_PREPARATION__SUCCESS,
  payload: { createPreparation },
});

const actionLoadCreatePreparationFail = error => ({
  type: ACTION_LOAD_CREATE_PREPARATION__FAIL,
  payload: { error },
});

export const actionLoadCreatePreparationRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_CREATE_PREPARATION__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/site/create/preparation',
      {}
    ).then(
      result => {
        dispatch(actionLoadCreatePreparationSuccess(result));
      },
      error => {
        dispatch(actionLoadCreatePreparationFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
